export default {
   makeNotification(context, value) {
      context.commit('makeNotification', value);
   },
   
   makeNotificationSound(context, value) {
      context.commit('makeNotificationSound', value);
   },
}